export * as SplashScreen from 'expo-splash-screen';
